var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3825.25 554.75 16.042 16.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2 {\n        fill: #828282;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search_",
    "data-name": "ic_search ",
    className: "cls-1",
    transform: "translate(-3859.65 504.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "cls-2",
    d: "M45.858,60.783h-.733l-.275-.275a5.738,5.738,0,0,0,1.467-3.85,5.958,5.958,0,1,0-5.958,5.958,5.738,5.738,0,0,0,3.85-1.467l.275.275v.733l4.583,4.583,1.375-1.375Zm-5.5,0a4.125,4.125,0,1,1,4.125-4.125A4.108,4.108,0,0,1,40.358,60.783Z",
    transform: "translate(0 -0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.bccdddcb3abe32c52da8dbccff55a251.svg";
export { ForwardRef as ReactComponent };